import type { FinancialProduct, WebPage, WithContext } from 'schema-dts';

import type { FinancialProductSource } from './types';

const buildFinancialProductSchema = (source: FinancialProductSource): WithContext<FinancialProduct> => ({
  '@context': 'https://schema.org',
  '@type': 'FinancialProduct',
  areaServed: source.areaServed,
  ...(source.category ? { category: source.category } : {}),
  description: source.description,
  mainEntityOfPage: {
    '@id': source.mainEntityOfPageId,
    '@type': 'WebPage',
  } as WebPage,
  name: source.name,
  // TODO: Move Offer schema to a dedicated utility and PR.
  // Include eligibility rules, validity windows, offeredBy for partners,
  // combined products, upsell scenarios, and controls for expired-offer indexing.
  provider: {
    '@type': 'Organization',
    name: source.provider.name,
    url: source.provider.url,
  },
  url: source.url,
});

export default buildFinancialProductSchema;
